var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-page',[_c('div',{staticClass:"sub-visual sub-visual--sv3"},[_c('v-container',[_c('h2',{staticClass:"sub-visual__title"},[_c('span',[_vm._v("PARTNERS")])])])],1),_c('partners-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }